import { HTMLAttributes } from 'react';
import styled, { css } from 'styled-components';

const localVariables = {
    iconSizeSmall: '30px',
    iconSizeBig: '40px',
    iconGap: '18px',
};

type StoreBenefitsProps = HTMLAttributes<HTMLUListElement> & { $isInline?: boolean };

export const StoreBenefitsStyled = styled.ul<StoreBenefitsProps>(
    ({ theme, $isInline }) => css`
        font-size: 15px;

        ${$isInline
            ? css`
                  display: flex;

                  li + li {
                      margin-left: ${localVariables.iconGap};
                  }
              `
            : css`
                  margin: 20px 0;

                  li {
                      display: flex;
                      align-items: center;
                      margin-bottom: ${localVariables.iconGap};
                  }

                  picture {
                      margin-right: ${localVariables.iconGap};
                  }
              `}

        img {
            width: ${$isInline ? localVariables.iconSizeSmall : localVariables.iconSizeBig};
            height: ${$isInline ? localVariables.iconSizeSmall : localVariables.iconSizeBig};
        }

        @media ${theme.mediaQueries.queryVl} {
            font-size: 16px;
        }
    `,
);

export const StoreBenefitsPlaceholderStyled = styled.li`
    width: 30px;
    height: 30px;

    & + li {
        margin-left: ${localVariables.iconGap};
    }
`;
